import { Flex, Image, Link, Text, VStack } from '@chakra-ui/react'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import { Trans, useTranslation } from 'react-i18next'

export const PaymentFooter = ({ source }: { source: string }) => {
	const { t } = useTranslation()

	const assetsBaseUrl =
		source === 'money_pot'
			? `${process.env.REACT_APP_POTS_URL}collect`
			: `${process.env.REACT_APP_PAYMENT_FORM_URL}l`
	return (
		<VStack align='center' pt={4} borderTop='1px solid' borderColor={BgColors.Z2}>
			<Flex align='center' gap={2}>
				<Text color={'#00286b'} fontWeight='bold' textTransform='uppercase'>
					{t('phone_form.verify_identity_footer_designed_by')}
				</Text>
				<Image
					src={`${assetsBaseUrl}/assets/img/payment/lydia-logotype.png`}
					alt='Lydia Logo'
					h='18px'
				/>
			</Flex>
			<Text color={TextColors.SECONDARY} fontSize='lg'>
				<Trans
					i18nKey='phone_form.verify_identity_footer_contact'
					components={{
						emailLink: (
							<Link
								href='mailto:hello@lydia.me'
								color={TextColors.HIGHLIGHT_ACTION}
								textDecoration='underline'
							/>
						)
					}}
				/>
			</Text>
		</VStack>
	)
}
